<template>
  <div>
    <h1 class="te-cookie-page-title co-display-8 mb-[3.75rem] mt-5 text-center leading-none md:mb-20">
      クッキーポリシー
    </h1>
    <div class="w-full">
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          クッキーとは
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          クッキーはWebサイトからご利用者様の端末に記録目的で送信される小さなテキストファイルです。クッキーはご利用者様の端末、通常Webブラウザを識別しますが、それ自体でご利用者様を個人として識別することはありません。
        </p>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold">
          クッキーの利用目的
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          クッキーはご利用者様に最適な状態でWebサイトを利用いただくために必要であり、使用している言語などやWebサイトにおける行動などを記録する際に利用します。<br>また、機能を向上させる、パフォーマンスを改善するために分析データを収集する、インターネットにおいてご利用者様をトラッキングすることにより当サイトもしくはアドテクパートナーからパーソナライズされた広告を表示する、またはソーシャルメディアでシェアする目的でも利用します。
        </p>
        <p class="mb-4 ml-4 leading-loose">
          ※ 当社では、Google Analyticsを使用してご利用者様のウェブサイトの利用状況（訪問者数と通信トラフィックソース等）を収集しています。データが収集、処理される仕組みについては、以下のサイトをご参照ください。<br><a
            class="te-cookie-link"
            href="https://policies.google.com/technologies/partner-sites?hl=ja"
            target="_blank"
          >https://policies.google.com/technologies/partner-sites</a><br><a
            class="te-cookie-link"
            href="https://policies.google.com/privacy?hl=ja"
            target="_blank"
          >https://policies.google.com/privacy</a>
        </p>
        <p class="ml-4 leading-loose">
          ※ 当社では、株式会社セールスフォース・ジャパンが提供するPardotを使用してご利用者様のウェブサイトの利用状況（訪問者数と通信トラフィックソース等）を収集しています。株式会社セールスフォース・ジャパンのプライバシーポリシー等については、以下のサイトをご参照ください。
        </p>
        <p class="mb-4 ml-4 leading-loose">
          <a
            class="te-cookie-link"
            href="https://www.salesforce.com/jp/company/privacy/"
            target="_blank"
          >https://www.salesforce.com/jp/company/privacy/</a>
        </p>
      </div>
      <div class="mb-10">
        <h3 class="co-display-11 mb-5 font-bold tracking-normal">
          クッキーの無効化について
        </h3>
        <p class="mb-4 ml-4 leading-loose">
          当サイトのご利用者様は、ブラウザの設定を変更することにより、クッキーを無効にすることができます。以下では、一般的なブラウザにおける設定方法を掲載しています。
        </p>
        <ul class="my-5 mb-10 ml-4 list-disc pl-7">
          <li class="mb-2">
            <a
              class="te-cookie-link"
              href="https://support.google.com/chrome/answer/95647"
              target="_blank"
            >Google Chrome</a>
          </li>
          <li class="mb-2">
            <a
              class="te-cookie-link"
              href="https://support.apple.com/ja-jp/HT201265"
              target="_blank"
            >Safari (iPhone,iPad)</a>
          </li>
          <li class="mb-2">
            <a
              class="te-cookie-link"
              href="https://support.apple.com/ja-jp/guide/safari/sfri11471/mac"
              target="_blank"
            >Apple Safari (Mac)</a>
          </li>
          <li class="mb-2">
            <a
              class="te-cookie-link"
              href="https://support.microsoft.com/ja-jp/help/17442/windows-internet-explorer-delete-manage-cookies"
              target="_blank"
            >Microsoft Internet Explorer</a>
          </li>
          <li class="mb-2">
            <a
              class="te-cookie-link"
              href="https://support.microsoft.com/ja-jp/help/4027947/microsoft-edge-delete-cookies"
              target="_blank"
            >Microsoft Edge</a>
          </li>
          <li class="mb-2">
            <a
              class="te-cookie-link"
              href="https://support.mozilla.org/ja/kb/cookies-information-websites-store-on-your-computer"
              target="_blank"
            >Mozilla Firefox</a>
          </li>
          <li class="mb-2">
            <a
              class="te-cookie-link"
              href="https://www.criteo.com/jp/privacy/"
              target="_blank"
            >Criteo</a>
          </li>
        </ul>
        <p class="mb-4 ml-4 leading-loose">
          なお、クッキーを無効にした場合、当サイトの機能の一部が利用できなくなる、一部のページが正しく表示されなくなる、または当社の一部のサービスが受けられなくなることがありますので、あらかじめご了承ください。
        </p>
      </div>
      <p class="text-right leading-loose">
        最終更新日：2023年3月29日
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

const options = {
  async setup() {
    definePageMeta({
      layout: 'te-side-menu'
    })
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'index',
    })
    return {
      title: 'クッキーポリシー |テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
            'テックアカデミーのクッキーポリシーです。クッキー情報のお取り扱いについて記載しています。',
            ogUrl: '/cookiepolicy',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-cookie-page-title {
  @media (min-width: 768px) {
    font-size: 2rem;
  }
}

.te-cookie-link {
  @media (max-width: 576px) {
    font-size: .6875rem;
  }
}
</style>
